import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
export function Authors() {
  return <section id="authors" className="w-full bg-paper py-28" data-id="element-20" data-mp="16qv1yiac7p17">
      <div className="mx-auto max-w-6xl px-6" data-id="element-21" data-mp="11stku2wh1zsd">
        <SectionHeading eyebrow="Meet the Publisher" title="Behind the imprint" data-id="element-22" data-mp="11tmimedgdeyd" />

        <div className="mt-16 grid lg:grid-cols-[420px_1fr] gap-14 items-center" data-id="element-23" data-mp="ws5jooej42kf">
          <motion.div initial={{
          opacity: 0,
          x: -24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="relative mx-auto" data-id="element-24" data-mp="1uhie5frad0tk">
            <div className="absolute -inset-3 border border-gold/40" data-id="element-25" data-mp="1fkzvxakrpgky" />
            <img src="https://cdn.magicpatterns.com/uploads/8oAvsJrWGNxSY26hMEWXqk/DeleonPublishingImg.jpg" alt="Fiery phoenix artwork" className="relative w-full max-w-md object-cover" data-id="element-26" data-mp="1fn40luqhqjma" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.1
        }} data-id="element-27" data-mp="3904u0sw8wrfi">
            <blockquote className="font-serif text-3xl sm:text-4xl leading-snug text-ink italic" data-id="element-28" data-mp="2z0e1gwr8wmi2">
              “A book should carry something worth keeping: a question, a truth, a moment of beauty that stays with the reader long after the last page.”
            </blockquote>
            <p className="mt-8 text-ink/70 leading-relaxed" data-id="element-29" data-mp="2uzu1zmj796sr">
              From our earliest titles exploring the ancient Egyptian concept of
              the soul to sweeping works of historical fiction, Deleon Publishing
              has been guided by a simple conviction: that the oldest questions
              are still the most alive.
            </p>
            <p className="mt-6 text-ink/70 leading-relaxed" data-id="element-30" data-mp="2batem2rz153i">
              We remain a small, independent press, by design. It lets us give each author and each manuscript the attention it deserves.
            </p>
            <div className="mt-8" data-id="element-31" data-mp="d1ce0z38qwqn">
              <p className="font-serif text-xl text-ink" data-id="element-32" data-mp="d018ouu5dgxf">The Deleon Editorial Team</p>
              <p className="text-gold text-sm tracking-wide" data-id="element-33" data-mp="83axaktaf9ic">Deleon Publishing LLC</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}